import { ErrorBoundary } from '@sentry/react';
import { useAtomValue } from 'jotai';
import { FunctionComponent, ReactNode } from 'react';
import { isMappedMetricPendingAtom } from '@/atoms/metric/metricFilterMapping';
import { useIsNarrowViewport } from '@/hooks/useIsNarrowViewport';
import { useVisDisplayMode } from '@/hooks/useVisDisplayMode';
import { VisDisplayMode } from '@/types/visualisation';
import { GeneralErrorBoundaryFallback } from '../errorBoundary/ErrorBoundaryFallback';
import { VisContentsContainer } from '../layout/VisContentsContainer';
import { PendingEventsTable } from '../tables/PendingEventsTable';

export const VisDisplaySection = ({
  EventsTableComponent,
  visualisationComponent,
  rowBreakpoint,
  insightComponent,
}: {
  EventsTableComponent: FunctionComponent;
  visualisationComponent: JSX.Element;
  rowBreakpoint?: 'lg' | 'xl' | 'none';
  insightComponent?: ReactNode;
}) => {
  const isNarrowViewport = useIsNarrowViewport();
  const [visDisplayMode] = useVisDisplayMode();
  const isMappingPending = useAtomValue(isMappedMetricPendingAtom);

  const isDisplayBoth = visDisplayMode === VisDisplayMode.BOTH;
  const isDisplayTable = visDisplayMode === VisDisplayMode.TABLE;
  const isDisplayVis = visDisplayMode === VisDisplayMode.VIS;

  return (
    <ErrorBoundary fallback={<GeneralErrorBoundaryFallback />}>
      <VisContentsContainer rowBreakpoint={rowBreakpoint}>
        {(isDisplayVis || isDisplayBoth) && (
          <div className="flex-1 min-w-0 bg-canvas-tertiary-main">{visualisationComponent}</div>
        )}
        {isNarrowViewport && (isDisplayVis || isDisplayBoth) && insightComponent}
        {(isDisplayTable || isDisplayBoth) && (
          <div className="flex-1 min-w-0 bg-canvas-tertiary-main">
            {isMappingPending ? <PendingEventsTable /> : <EventsTableComponent />}
          </div>
        )}
      </VisContentsContainer>
    </ErrorBoundary>
  );
};
